import { ApiError, CancelButton, SubmitButton } from "components";
import { connect, useSelector } from "react-redux";
import { updateDcddMembershipStatus } from "../store/action";
import { FormEvent, useEffect, useState } from "react";
import { DcddMembershipStatus } from "props/enum";
import { DcddMembershipPlanProp } from "../store/actionType";

interface OwnProps {
  dcddMembershipData: DcddMembershipPlanProp;
  onClose: () => void;
}
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & OwnProps;
const HandleUpdateStatus: React.FC<Props> = ({
  dcddMembershipData,
  onUpdateStatus,
  onClose,
}) => {
  const dcddMemebershipState = useSelector(
    (state: any) => state.dcddMembership?.genericDcddMembershipState
  );
  const [apiError, setApiError] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    const membershipId = dcddMembershipData.id.toString()
    onUpdateStatus(membershipId)
  };
  const currentStatus = dcddMembershipData.status
  const newStatus =
    currentStatus === DcddMembershipStatus.Active
      ? DcddMembershipStatus.Inactive
      : DcddMembershipStatus.Active;

  useEffect(() => {
    if (!dcddMemebershipState.isLoading && submitted) {
      if (dcddMemebershipState.error) {
        setApiError(dcddMemebershipState.error); // show error
      } else {
        setApiError(null);
        onClose();
      }
    }
  }, [dcddMemebershipState.isLoading, dcddMemebershipState.error, submitted]);
  return (
    <>
      {" "}
      <div className="text-center font-bold my-2 text-lg">Confirmation</div>
      <div className="text-center font-bold text-md my-5">
        Are you sure, you want to {newStatus}?
      </div>
      <div className="flex justify-evenly">
        <CancelButton onClick={onClose}>No</CancelButton>
        <SubmitButton
          onClick={(e) => {
            handleSave(e);
          }}
        >
          Yes
        </SubmitButton>
      </div>
      <div>{apiError && <ApiError>{apiError}</ApiError>}</div>
    </>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
  onUpdateStatus: (MembershipId: string) =>
    dispatch(updateDcddMembershipStatus(MembershipId)),
});
export default connect(null, mapDispatchToProps)(HandleUpdateStatus);
